var kvlGlobalLoaded = window.kvlGlobalLoaded || false;
var kvlGa3DlSupport = false;
window.pcdpLayer = window.pcdpLayer || [];
window.pcdp = function () { window.pcdpLayer.push(arguments); };
var kvlGtmDataLayer = window.kvlGtmDataLayer || window.dataLayer || [];
var kvlDlEventNameHolderList = ["event", "event_name", "1"];
var kvlProdCurrency = "EUR";
var kvlTransactionCurrency = "EUR";
let kvlGtmLoad = false;
let lastDataLayerLength = 0;
import {
    COOKIE_HOURS_IN_A_DAY,
    COOKIE_MINUTES_IN_A_HOUR,
    COOKIE_SECONDS_IN_A_MINUTE,
    COOKIE_MILISECONDS_IN_A_SECOND,
    COOKIE_MAILING_ANON_NAME,
    COOKIE_MAILING_ANON_EXP_DAYS,
    COOKIE_MAILING_ANON_SALT,
} from "../utilities/constants";
var kevelHelper = require("./utils");

if (window.dataLayer) {
    lastDataLayerLength = window.dataLayer.length;
}

const kvlNormalizePrices = (price) => {
    if (price === undefined) return 0;
    let priceNum = 0;
    if (typeof price === "string") {
        priceNum = parseFloat(price.replace(",", ".").replace(/[\s$€£¥₣₹]/g, "")) || 0;
    }
    if (typeof price === "number") {
        priceNum = price;
    }
    return priceNum;
};

const kvlAddProductFields = (fields, prods, i, product, varType, fieldType) => {
    for (let a = 0; a < fields.length; a++) {
        if (prods[i][fields[a]] !== undefined) {
            if (varType === "int") {
                if (fieldType === "custom") {
                    product.customFields[fields[a]] = kvlNormalizePrices(prods[i][fields[a]]);
                } else {
                    product[fields[a]] = kvlNormalizePrices(prods[i][fields[a]]);
                }
            } else {
                if (fieldType === "custom") {
                    product.customFields[fields[a]] = prods[i][fields[a]].toString().toLowerCase();
                } else {
                    product[fields[a]] = prods[i][fields[a]].toString().toLowerCase();
                }
            }
        }
    }
};

const kvlMakeProductsArray = (products, dlEventMessage) => {
    if (products == undefined) { return []; }
    var productsArray = [];

    try {
        kvlProdCurrency = ((dlEventMessage.ecommerce || {}).currencyCode) ? dlEventMessage.ecommerce.currencyCode : (dlEventMessage.eventModel || {}).currency;
        if (kvlProdCurrency === undefined) {
            kvlProdCurrency = kvlTransactionCurrency;
        }
    } catch (err) {
        console.log(`Kevel Audience: error trying to convert currency, err: ${err.message}`);
    }

    var prods = [];
    if (products[0] == undefined) {
        prods[0] = products;
    } else {
        prods = products;
    }

    for (var i = 0, ii = prods.length; i < ii; i++) {
        var product = {};

        if (Object.prototype.hasOwnProperty.call(prods[i], "id")) {
            product = {
                id: prods[i].id,
                price: kvlNormalizePrices(prods[i].price),
                priceTotal: prods[i].priceTotal ? kvlNormalizePrices(prods[i].priceTotal) : "",
                currency: prods[i].currency ? prods[i].currency : kvlProdCurrency,
                customFields: {}
            };

            if (prods[i].category && typeof (prods[i].category) == "string") { 
                product.secondaryCategory = prods[i].category.replace(/\//g, "|").toLowerCase();
            }
            if (typeof (prods[i].variant) == "string" && prods[i].variant.trim() !== "") { 
                product.sku = product.id; 
                product.id = prods[i].variant.toLowerCase(); 
            } else {
                product.sku = product.id;
            }

            if (prods[i].coupon != undefined) { product.promotions = [prods[i].coupon.toString().toLowerCase()]; }
            if (prods[i].position != undefined) { product.position = prods[i].position; }
            if (prods[i].list_position != undefined) { product.position = prods[i].list_position; }
            if (prods[i].discount != undefined) { product.discount = { value: kvlNormalizePrices(prods[i].discount) }; }
            const kvlCustomProductFields = ["list", "color", "size"];
            kvlAddProductFields(kvlCustomProductFields, prods, i, product, "str", "custom");
            kvlAddProductFields(["tax", "shipping", "quantity"], prods, i, product, "int", "std");
        } else {
            if (Object.prototype.hasOwnProperty.call(prods[i], "item_id")) {
                product = {
                    id: prods[i].item_id,
                    price: kvlNormalizePrices(prods[i].price),
                    priceTotal: prods[i].priceTotal ? kvlNormalizePrices(prods[i].priceTotal) : "",
                    currency: prods[i].currency ? prods[i].currency : kvlProdCurrency,
                    customFields: {}
                };

                if (typeof (prods[i].item_variant) == "string" && prods[i].item_variant.trim() !== "") { 
                    product.sku = product.id;
                    product.id = prods[i].item_variant.toLowerCase(); 
                } else {
                    product.sku = product.id;
                }

                if (prods[i].coupon != undefined) { product.promotions = [prods[i].coupon.toString().toLowerCase()]; }
                if (prods[i].index != undefined) { product.index = prods[i].list_position; }
                if (prods[i].discount != undefined) { product.discount = { value: kvlNormalizePrices(prods[i].discount) }; }

                const kvlCustomProductFields = ["list", "color", "size"];
                kvlAddProductFields(kvlCustomProductFields, prods, i, product, "str", "custom");
                kvlAddProductFields(["tax", "shipping", "quantity"], prods, i, product, "int", "std");

                if (Object.prototype.hasOwnProperty.call(prods[i], "item_list_name")) {
                    product.customFields.list = prods[i].item_list_name.toLowerCase();
                } else {
                    if (((dlEventMessage.eventModel || {}).item_list_name) != undefined) {
                        product.customFields.list = dlEventMessage.eventModel.item_list_name.toLowerCase();
                    }
                }
            }
        }

        productsArray.push(product);
    }

    return productsArray;
};

const kvlTrackProductImpression = (impressions, dlEventMessage) => {
    let kvlProductArray = [];
    if (impressions !== undefined) {
        kvlProductArray = kvlMakeProductsArray(impressions, dlEventMessage);
        pcdp("event", "track", {
            type: "productImpression",
            products: kvlProductArray
        });
    }
};

const kvlTrackProductView = (detail, dlEventMessage) => {
    let kvlProductArray = [];
    if (detail !== undefined) {
        kvlProductArray = kvlMakeProductsArray(detail, dlEventMessage);
        pcdp("event", "track", {
            type: "productView",
            product: kvlProductArray[kvlProductArray.length - 1]
        });
    }
};

const kvlTrackSelectItem = (detail, dlEventMessage) => {
    let kvlProductArray = [];
    if (detail !== undefined) {
        kvlProductArray = kvlMakeProductsArray(detail, dlEventMessage);
        pcdp("event", "track", {
            type: "productClick",
            product: kvlProductArray[kvlProductArray.length - 1]
        });
    }
};

const kvlTrackAddToCart = (items, dlEventMessage) => {
    let kvlProductArray = [];
    if (items !== undefined) {
        kvlProductArray = kvlMakeProductsArray(items, dlEventMessage);
        pcdp("event", "track", {
            type: "addToCart",
            product: kvlProductArray[kvlProductArray.length - 1]
        });
    }
};

const kvlTrackRemoveFromCart = (items, dlEventMessage) => {
    let kvlProductArray = [];
    if (items !== undefined) {
        kvlProductArray = kvlMakeProductsArray(items, dlEventMessage);
        const eventData = {
            type: "removeFromCart",
        };
        if (Array.isArray(kvlProductArray) && kvlProductArray.length === 1) {
            eventData.product = kvlProductArray[0];
        } else if (Array.isArray(kvlProductArray) && kvlProductArray.length > 1) {
            eventData.products = kvlProductArray;
        }
        pcdp("event", "track", eventData);
    }
};

const kvlTrackWishlist = (items, dlEventMessage) => {
    let kvlProductArray = [];
    if (items !== undefined) {
        kvlProductArray = kvlMakeProductsArray(items, dlEventMessage);
        pcdp("event", "track", {
            type: dlEventMessage.event,
            product: kvlProductArray[kvlProductArray.length - 1]
        });
    }
};

const kvlTrackViewCart = (items, dlEventMessage) => {
    let kvlProductArray = [];
    if (items !== undefined) {
        kvlProductArray = kvlMakeProductsArray(items, dlEventMessage);
        pcdp("event", "track", {
            type: "cartView",
            products: kvlProductArray
        });
    }
};

const kvlTrackCheckoutStep = (items, dlEventMessage) => {
    let kvlProductArray = [];
    let kvlCheckoutStep = 0;
    if (items !== undefined) {
        kvlProductArray = kvlMakeProductsArray(items, dlEventMessage);
        kvlCheckoutStep = (((dlEventMessage.ecommerce || {}).checkout || {}).actionField || {}).step || (dlEventMessage.eventModel || {}).checkout_step;
        pcdp("event", "track", {
            type: "checkoutStep",
            step: kvlCheckoutStep,
            products: kvlProductArray
        });

        // Saves the kvlProductArray in the sessionStorage, to be used in the order confirmation page.
        if (kvlProductArray.length > 0) {
            window.sessionStorage.setItem("kvlProductArray", JSON.stringify(kvlProductArray));
        }
    }
};

const kvlTrackOrderPlace = () => {
    let kvlProductArray = JSON.parse(window.sessionStorage.getItem("kvlProductArray")) || [] ;
    let kvlTotal = 0;
    kvlProductArray.forEach((product, i, arr) => {
        arr[i].productId = arr[i].id;
        delete arr[i].id;
        arr[i].itemGroupId = arr[i].variant ? arr[i].variant : "";
        delete arr[i].variant;
        arr[i].quantity = arr[i].quantity ? arr[i].quantity : 1;
        arr[i].total = arr[i].priceTotal;
        delete arr[i].discount;
        delete arr[i].price;
        delete arr[i].priceTotal;
        arr[i].tax = arr[i].tax ? arr[i].tax : 0;
        arr[i].shipping = arr[i].shipping ? arr[i].shipping : 0;
        arr[i].subtotal = arr[i].total - arr[i].tax - arr[i].shipping;

        kvlTotal += arr[i].total;
    });

    try {
        const $orderNo = $(".js-order-number");
        if ($orderNo && $orderNo.length > 0) {
            let orderNo = $orderNo.val();
            var kvlOrderDetails = {
                type: "orderPlace",
                lineItems: kvlProductArray,
                order: {
                    id: orderNo,
                    paymentMethod: null,
                    currency: kvlTransactionCurrency,
                    total: kvlTotal,
                    subtotal: null,
                    tax: null,
                    shipping: null,
                    promotions: null,
                    source: "web"
                }
            };
            pcdp("event", "track", kvlOrderDetails);
        }
    } catch (err) {
        console.log("Kevel Audience: couldnt track order, err: " + err.message);
    }
};

const kvlTrackSearch = (dlEventMessage) => {
    var term = {};
    if (dlEventMessage && dlEventMessage[0]) {
        term = dlEventMessage[0].term;
    }

    pcdp("event", "track", {
        type: "search",
        query: term
    });
};

const KAHandlePromoEvents = (items, dlEventMessage) => {
    pcdp("event", "track", {
        type: "custom",
        customType: dlEventMessage.event,
        promo: items && Array.isArray(items) && items.length === 1 ? items[0] : items
    });
};

const kvlTrackInterconnection = (items, dlEventMessage) => {
    const interconnectionValue = dlEventMessage.interconnection ? dlEventMessage.interconnection.toString() : "false";
    const customType = dlEventMessage.interconnection ? "acceptInterconnection" : "rejectInterconnection";

    const eventObject = {
        type: "custom",
        customFields: {
            interconnection: interconnectionValue,
        },
        customType: customType
    };

    if (dlEventMessage.interconnection && dlEventMessage.mailingUserId) {
        eventObject.user = {
            id: dlEventMessage.mailingUserId,
            type: "crm"
        };
    }

    pcdp("event", "track", eventObject);
};

const KAHandleInitDataEvents = (items, dlEventMessage) => {
    pcdp("event", "track", {
        type: "custom",
        customType: dlEventMessage.event,
        customFields: items && Array.isArray(items) && items.length === 1 ? items[0] : items
    });
};

const KAHandleIPaperClickEvents = (items) => {
    pcdp("event", "track", {
        type: "custom",
        customType: "open_ipaper",
        customFields: items && items.customFields
    });
};

const kvlHandleEcommerceEvents = (dlEventMessage) => {
    if (Object.prototype.hasOwnProperty.call(dlEventMessage, "ecommerce")) {
        if (Object.prototype.hasOwnProperty.call(dlEventMessage.ecommerce, "impressions")) {
            kvlTrackProductImpression(dlEventMessage.ecommerce.impressions, dlEventMessage);
        }
        if ((dlEventMessage.ecommerce.detail || {}).products !== undefined) {
            kvlTrackProductView(dlEventMessage.ecommerce.detail.products, dlEventMessage);
        }
        if ((dlEventMessage.ecommerce.add || {}).products !== undefined) {
            kvlTrackAddToCart(dlEventMessage.ecommerce.add.products, dlEventMessage);
        }
        if ((dlEventMessage.ecommerce.remove || {}).products !== undefined) {
            kvlTrackRemoveFromCart(dlEventMessage.ecommerce.remove.products, dlEventMessage);
        }
        if (dlEventMessage.ecommerce.checkout !== undefined) {
            kvlTrackCheckoutStep((dlEventMessage.ecommerce.checkout.products || []), dlEventMessage);
        }
        if (dlEventMessage.ecommerce.purchase !== undefined) {
            kvlTrackOrderPlace();
        }
    }
};

const KAHandleGA4Events = (eventFunctionToCall, dlEventMessage) => {
    let items = [];
    if (Object.prototype.hasOwnProperty.call(dlEventMessage, "ecommerce")) {
        if (Object.prototype.hasOwnProperty.call(dlEventMessage.event, "add_to_cart") || Object.prototype.hasOwnProperty.call(dlEventMessage.event, "remove_from_cart")) {
            // Directly access items for add_to_cart and remove_from_cart events, due to structure update in the context of COL-13708.
            if (Object.prototype.hasOwnProperty.call(dlEventMessage.ecommerce, "items")) {
                items = dlEventMessage.ecommerce.items;
            }
        } else if (Object.prototype.hasOwnProperty.call(dlEventMessage.ecommerce, "items")) {
            items = dlEventMessage.ecommerce.items;
        } else if (Object.prototype.hasOwnProperty.call(dlEventMessage.ecommerce, "impressions")) {
            items = dlEventMessage.ecommerce.impressions;
        } else if (Object.prototype.hasOwnProperty.call(dlEventMessage.ecommerce, "click")) {
            items = dlEventMessage.ecommerce.click.products;
        } else if ((dlEventMessage.ecommerce.detail || {}).products !== undefined) {
            items = dlEventMessage.ecommerce.detail.products;
        } else if ((dlEventMessage.ecommerce.add || {}).products !== undefined) {
            items = dlEventMessage.ecommerce.add.products;
        } else if ((dlEventMessage.ecommerce.remove || {}).products !== undefined) {
            items = dlEventMessage.ecommerce.remove.products;
        } else if (dlEventMessage.ecommerce.checkout !== undefined) {
            items = (dlEventMessage.ecommerce.checkout.products || []);
        } else if (dlEventMessage.ecommerce.purchase !== undefined) {
            items = (dlEventMessage.ecommerce.purchase.products || []);
        } else if (dlEventMessage.ecommerce.promoView !== undefined) {
            items = (dlEventMessage.ecommerce.promoView.promotions || []);
        }
    } else {
        if (Object.prototype.hasOwnProperty.call(dlEventMessage, "eventModel")) {
            if (Object.prototype.hasOwnProperty.call(dlEventMessage.eventModel, "items")) {
                items = dlEventMessage.eventModel.items;
            }
        } else {
            for (const key in dlEventMessage) {
                if (Object.prototype.hasOwnProperty.call(dlEventMessage, key)) {
                    if (dlEventMessage && dlEventMessage[key] && Object.prototype.hasOwnProperty.call(dlEventMessage[key], "items")) {
                        items = dlEventMessage[key].items;
                    }
                }
            }
        }

        if (dlEventMessage && dlEventMessage.event && dlEventMessage.event == "initial_data") {
            items[0] = extractSpecialCaseData(dlEventMessage);
        }
    }
    eventFunctionToCall(items, dlEventMessage);
};

const extractSpecialCaseData = (dlEventMessage) => ({
    "cartaoContinente": dlEventMessage.user_data.cartao_continente,
    "entregaZero": dlEventMessage.user_data.entrega_zero,
    "store": dlEventMessage.user_data.store,
    "deliveryMethod": dlEventMessage.user_data.delivery_method,
    "firstOrder": dlEventMessage.user_data.first_order,
    "customerGroups": dlEventMessage.user_data.customer_groups,
    "deviceType": dlEventMessage.page_data.device_type,
    "channel": dlEventMessage.page_data.channel,
    "view": dlEventMessage.page_data.view
});

const kvlHandleGA4ImpressionEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackProductImpression, dlEventMessage);
const kvlHandleGA4ViewEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackProductView, dlEventMessage);
const kvlHandleGA4AddToCartEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackAddToCart, dlEventMessage);
const kvlHandleGA4InterconnectionEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackInterconnection, dlEventMessage);
const kvlHandleGA4RemoveFromCartEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackRemoveFromCart, dlEventMessage);
const kvlHandleGA4AddToWishlistEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackWishlist, dlEventMessage);
const kvlHandleGA4RemoveFromWishlistEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackWishlist, dlEventMessage);
const kvlHandleGA4PurchaseEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackOrderPlace, dlEventMessage);
const kvlHandleGA4ViewCartEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackViewCart, dlEventMessage);
const kvlHandleGA4CheckoutEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackCheckoutStep, dlEventMessage);
const kvlHandleGA4SelectItemEvents = (dlEventMessage) => KAHandleGA4Events(kvlTrackSelectItem, dlEventMessage);
const kvlHandleGA4SearchEvents = (dlEventMessage) => kvlTrackSearch(dlEventMessage);
const kvlHandleGA4PromoEvents = (dlEventMessage) => KAHandleGA4Events(KAHandlePromoEvents, dlEventMessage);
const kvlHandleGA4InitialDataEvents = (dlEventMessage) => KAHandleGA4Events(KAHandleInitDataEvents, dlEventMessage);
const kvlHandleGA4IPaperClickEvents = (dlEventMessage) => KAHandleIPaperClickEvents(dlEventMessage);

const kvlTrackProductImpressionBulk = () => {
    kvlTrackProductImpression(window.pcdpImpsProductsLayer, window.pcdpImpsProductsEcomEvent);
};

const handleObserverConfig = () => {
    const observerConfig = {
        "impressions": kvlHandleGA4ImpressionEvents,
        "interconnection": kvlHandleGA4InterconnectionEvents,
        "view_item": kvlHandleGA4ViewEvents,
        "add_to_cart": kvlHandleGA4AddToCartEvents,
        "remove_from_cart": kvlHandleGA4RemoveFromCartEvents,
        "addToWishlist": kvlHandleGA4AddToWishlistEvents,
        "removeFromWishlist": kvlHandleGA4RemoveFromWishlistEvents,
        "productClick": kvlHandleGA4SelectItemEvents,
        "promoView": kvlHandleGA4PromoEvents,
        "promoClick": kvlHandleGA4PromoEvents,
        "checkoutStep1": kvlHandleGA4ViewCartEvents,
        "begin_checkout": kvlHandleGA4CheckoutEvents,
        "purchase": kvlHandleGA4PurchaseEvents,
        "initial_data": kvlHandleGA4InitialDataEvents,
        "iPaperClickEvents": kvlHandleGA4IPaperClickEvents
    };

    for (const a of kvlDlEventNameHolderList) {
        if (a.indexOf("search") !== -1) {
            observerConfig[a] = kvlHandleGA4SearchEvents;
        }
        pcdp("observe", kvlGtmDataLayer, observerConfig, a);
    }
};

const handleEvents = (elm) => {
    for (const a of kvlDlEventNameHolderList) {
        if (elm[a] === "view_item") { kvlHandleGA4ViewEvents(elm); }
        if (elm[a] === "impressions") { kvlHandleGA4ImpressionEvents(elm); }
        if (elm[a] === "add_to_cart") { kvlHandleGA4AddToCartEvents(elm); }
        if (elm[a] === "remove_from_cart") { kvlHandleGA4RemoveFromCartEvents(elm); }
        if (elm[a] === "addToWishlist") { kvlHandleGA4AddToWishlistEvents(elm); }
        if (elm[a] === "removeFromWishlist") { kvlHandleGA4RemoveFromWishlistEvents(elm); }
        if (elm[a] === "productClick") { kvlHandleGA4SelectItemEvents(elm); }
        if (elm[a] === "promoView") { kvlHandleGA4PromoEvents(elm); }
        if (elm[a] === "promoClick") { kvlHandleGA4PromoEvents(elm); }
        if (elm[a] === "checkoutStep1") { kvlHandleGA4ViewCartEvents(elm); }
        if (elm[a] === "begin_checkout") { kvlHandleGA4CheckoutEvents(elm); }
        if (elm[a] === "checkoutStep4") { kvlHandleGA4CheckoutEvents(elm); }
        if (elm[a] === "initial_data") { kvlHandleGA4InitialDataEvents(elm); }
        if (typeof elm[a] === "string" && elm[a].indexOf("search") !== -1) { kvlHandleGA4SearchEvents(elm); }

        let $isOrderConfirmationPage = $(".ct-order-confirmation--container");
        if ($isOrderConfirmationPage && $isOrderConfirmationPage.length > 0 && elm[a] === "purchase") {
            kvlHandleGA4PurchaseEvents(elm);
        }
    }
};

const kvlLoad = () => {
    kvlGtmDataLayer.forEach((elm) => {
        handleEvents(elm);
        if (typeof (elm["ecommerce"]) === "object" && kvlGa3DlSupport) {
            kvlHandleEcommerceEvents(elm);
        }
        if (elm["event"] === "gtm.load") {
            kvlGtmLoad = true;
        }
    });

    if (kvlGtmLoad && ((window.pcdpImpsProductsLayer || []).length > 0)) {
        kvlTrackProductImpressionBulk();
    } else {
        pcdp("observe", kvlGtmDataLayer, { "gtm.load": kvlTrackProductImpressionBulk }, "event");
    }

    handleObserverConfig();
};

const updateKvlGtmDataLayer = () => {
    if (!kvlGlobalLoaded || !window.dataLayer || (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing === false)) {
        return;
    }
    const newEvents = window.dataLayer.slice(lastDataLayerLength);
    kvlGtmDataLayer = [...kvlGtmDataLayer, ...newEvents];
    newEvents.forEach(elm => {
        handleEvents(elm);
    });
    lastDataLayerLength = window.dataLayer.length;

    handleObserverConfig();
};
   
const initKevelAudienceEvents = () => {
    window.addEventListener("CookiebotOnLoad", function () {
        if (kvlGlobalLoaded || !window.dataLayer || !window.Cookiebot.consent.marketing) return;

        const pageDataElem = $(".page-data-kevel-audience")[0];
        if (!pageDataElem) return;

        const rawData = $(pageDataElem).attr("data-page-data-kevel-audience");
        const { audienceSrc, clientId } = JSON.parse(rawData || "{}");
        if (!audienceSrc || !clientId) return;

        let userId = window.sessionStorage.getItem("mailingUserId");
        let mailingUserId = "";
        let mailingAnonId = kevelHelper.getAnonIDValue();
        const spanElement = $(".page-data-kevel-audience-mailing-user-id");

        if (!userId) {
            if (spanElement.length) {
                userId = spanElement.data("page-data-kevel-audience-mailing-user-id");
                if (userId && userId != "") {
                    window.sessionStorage.setItem("mailingUserId", userId);
                }
                if ((userId && userId != "") || spanElement.data("page-data-kevel-audience-accept-interconnection") == true) {
                    mailingAnonId = setMailingAnonIdCookie();
                }
            }
        }

        const $userLoginNotAuthenticated = $(".user-unauthenticated");
        const $registrationLink = $(".ct-user-dropdown--registration-link");

        if ($userLoginNotAuthenticated.length || $registrationLink.length) {
            mailingUserId = userId;
            userId = null;
            window.sessionStorage.removeItem("mailingUserId");
        } else if (spanElement.length && spanElement.data("page-data-kevel-audience-accept-interconnection") == false) {
            deleteMailingAnonIdCookie();
            mailingAnonId = null;
            window.sessionStorage.removeItem("mailingUserId");
            userId = null;
        }

        // Checks if the cookie __cq_uuid has value. If not, the event should not be sent to Kevel Audience.
        if (!document.cookie.split("; ").find(row => row.startsWith("__cq_uuid="))?.split("=")[1]) return;

        var user;
        if (userId) {
            user = { 
                type: "crm", 
                id: userId 
            }; 
        } else if (mailingAnonId?.trim()) {
            user = { 
                type: "mailingAnonId", 
                id: mailingAnonId 
            };
        } else {
            userId = document.cookie.split("; ").find(row => row.startsWith("__cq_uuid="))?.split("=")[1];
            if (userId) {
                user = { 
                    id: userId
                };
            } else {
                return;
            }
        }

        if (!userId && !mailingAnonId) return;

        // Checks if the cookie user.id has value. If not, the event should not be sent to Kevel Audience.
        if (!user?.id?.trim()) return;

        pcdp("set", "track", {
            clientId: clientId,
            siteId: document.location.host,
            ...user && { user }
        });

        pcdp("event", "track", {
            type: "pageView",
            title: document.title,
            pageType: "",
            category: ""
        });

        pcdp("event", "activation", {
            containerId: "web",
            ...user && { user }
        });

        if (mailingUserId && mailingAnonId) {
            pcdp("event", "match", { 
                "providerId": "web", 
                "user": [
                    { 
                        "type": "crm", 
                        "id": mailingUserId 
                    },
                    { 
                        "type": "mailingAnonId", 
                        "id": mailingAnonId 
                    }],
                "cookies": "false"
            });
        }

        const kvlScript = document.createElement("script");
        kvlScript.src = audienceSrc;
        kvlScript.async = true;
        kvlScript.onload = kvlLoad;
        document.head.appendChild(kvlScript);

        kvlGlobalLoaded = true;
    });
};

const setMailingAnonIdCookie = () => {
    const crypto = require("crypto");

    let date = new Date();
    date.setTime(date.getTime() + (COOKIE_MAILING_ANON_EXP_DAYS * COOKIE_HOURS_IN_A_DAY * COOKIE_MINUTES_IN_A_HOUR * COOKIE_SECONDS_IN_A_MINUTE * COOKIE_MILISECONDS_IN_A_SECOND));

    let mailingAnonIDValue = crypto.createHash("sha256").update(kevelHelper.getCookieUUIDValue() + COOKIE_MAILING_ANON_SALT).digest("hex");
    document.cookie = COOKIE_MAILING_ANON_NAME + "=" + mailingAnonIDValue + "; expires=" + date.toUTCString() + "; path=/";
    return mailingAnonIDValue;
};

const deleteMailingAnonIdCookie = () => {
    document.cookie = COOKIE_MAILING_ANON_NAME + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
};

module.exports = {
    kvlMakeProductsArray: kvlMakeProductsArray,
    initKevelAudienceEvents: initKevelAudienceEvents,
    updateKvlGtmDataLayer: updateKvlGtmDataLayer,
    KAHandlePromoEvents: KAHandlePromoEvents,
    deleteMailingAnonIdCookie: deleteMailingAnonIdCookie
};
